"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const MapSideBarPanel_vue_1 = __importDefault(require("./MapSideBarPanel.vue"));
const parcel_1 = __importDefault(require("@becrop/components/Results/DistroTool/controllers/services/parcel"));
const ViewZero_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/ViewZero.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
let MapSideBarPanelFields = class MapSideBarPanelFields extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.currentField = null;
        this.searchParameter = '';
    }
    updateCurentField() {
        const field = this.fields.find(field => `${field.name}${field.id}` === this.fieldActiveKey);
        this.currentField = field;
    }
    jumpScroll() {
        var _a;
        let fieldsNavigation = this.$refs.fieldsNavigation;
        let currentElemnt = fieldsNavigation.querySelector('li[data-id="' + ((_a = this.currentField) === null || _a === void 0 ? void 0 : _a.id) + '"]');
        currentElemnt === null || currentElemnt === void 0 ? void 0 : currentElemnt.scrollIntoView({
            behavior: 'smooth',
        });
    }
    mainActionClicked(field) {
        this.$emit('updateFieldActiveKey', `${field.name}${field.id}`);
        setTimeout(() => {
            this.$emit('mainActionClicked', field);
        }, 1000);
    }
    focusField(field) {
        this.$emit('focusField', field);
    }
    get fields() {
        var _a, _b, _c, _d;
        const projectFields = (_b = (_a = this.currentProject) === null || _a === void 0 ? void 0 : _a.fields) !== null && _b !== void 0 ? _b : [];
        const farmFields = (_d = (_c = this.currentFarm) === null || _c === void 0 ? void 0 : _c.fields_linked_to_projects) !== null && _d !== void 0 ? _d : [];
        const currentFields = projectFields.length > 0 ? projectFields : farmFields;
        if (!this.searchParameter.trim())
            return currentFields;
        const searchParam = this.searchParameter.toLowerCase().trim();
        return currentFields.filter(field => field.name.toLowerCase().includes(searchParam) ||
            field.crop.name.toLowerCase().includes(searchParam));
    }
    parcelSvg(geodata) {
        return (0, parcel_1.default)(geodata, 50, 50);
    }
    parcelFillColor(field) {
        var _a;
        if (field.crop) {
            return `${(_a = field.crop) === null || _a === void 0 ? void 0 : _a.color}50`;
        }
        else
            return '#eebb5450';
    }
    parcelStrokeColor(field) {
        var _a;
        if (field.crop) {
            return (_a = field.crop) === null || _a === void 0 ? void 0 : _a.color;
        }
        else
            return '#eebb54';
    }
    selectField(field) {
        if (this.currentField === field) {
            this.currentField = null;
            this.$emit('updateFieldActiveKey', '');
        }
        else {
            this.currentField = field;
            this.$emit('updateFieldActiveKey', `${field.name}${field.id}`);
        }
    }
    isFieldActive(field) {
        if (this.currentField)
            return field.id === this.currentField.id;
        else
            false;
    }
    searchField(newSearchParameter) {
        this.searchParameter = newSearchParameter;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], MapSideBarPanelFields.prototype, "currentFarm", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], MapSideBarPanelFields.prototype, "currentProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapSideBarPanelFields.prototype, "isLoadingOpenReport", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' })
], MapSideBarPanelFields.prototype, "fieldActiveKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('fieldActiveKey')
], MapSideBarPanelFields.prototype, "updateCurentField", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('currentField')
], MapSideBarPanelFields.prototype, "jumpScroll", null);
MapSideBarPanelFields = __decorate([
    (0, vue_property_decorator_1.Options)({ components: { MapSideBarPanel: MapSideBarPanel_vue_1.default, Search: bmk_ui_framework_1.Search, ViewZero: ViewZero_vue_1.default, FilterIcon: bmk_ui_framework_1.FilterIcon, Button: bmk_ui_framework_1.Button, ArrowDown: lucide_vue_next_1.ArrowDown, Focus: lucide_vue_next_1.Focus } })
], MapSideBarPanelFields);
exports.default = MapSideBarPanelFields;
